export function paramsToQueryString(params: Object): string {
	if (!params) {
		return ''
	}

	const query = new URLSearchParams()

	Object.keys(params).forEach((key) => {
		const value = params[key]

		if (value !== undefined && value !== null) {
			query.append(key, value.toString())
		}
	})

	return '?' + query.toString()
}

export function processParams(params?: Record<string, string | string[]>): Record<string, string> {
	const processedParams: Record<string, string> = {}

	if (params) {
		for (const key in params) {
			const value = params[key]
			processedParams[key] = Array.isArray(value) ? value.join(',') : value
		}
	}

	return processedParams
}
